import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
// import { AccountService } from "../../shared/services/account.service";
// import { LauncherService } from "../../shared/services/launcher.service";
// import { UtilsService } from "../../shared/services/utils.service";
import { LanguageService } from "../../shared/services/language.service";
import { LikeButtonService} from "../../shared/services/like-button.service";
import { Router, ActivatedRoute } from '@angular/router';
// import { AppService } from "../../shared/services/app.service";

declare var $:any;
import { isBrowser } from '../../shared/thirdparty/isBrowser'
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-demo',
    templateUrl: './demo.component.html',
    styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {

    @ViewChild('webGLBuild') webGLBuild: any;

    public twitterUrl

    public currentLang

    public btnIsVisible = true
    public showSocialBtn = false

    public userAlredyLike = false

    public btnLikeName = 'demo'
    public staticLikeNumber = 494
    public likeNumber = 0

    public showApp = true
    public step = 'start'
    public iframe = null
    public displayEndText = false
    public pointerLocked = false

    public like = false

    public shareLink = ''

    public gratitudes = {
        startPlay : false,
        endPlay : false,
        share : false,
        replay : false
    }

    constructor(
        public renderer : Renderer2,
        // public accountService: AccountService,
        // public launcherService: LauncherService,
        // public utilsService: UtilsService,
        // public appService: AppService,
        public router: Router,
        public route: ActivatedRoute,
        public translate : TranslateService,
        public language : LanguageService,
        public buttonLike: LikeButtonService
    ) { }

    ngOnInit(): void {
        this.generateShareLink()
        this.getLikeNumberOnPage()
        this.checkUserLangForTwitterUrl()
    }

    buildEvent(e){
        if(isBrowser()){
            if(e && e == 'if-webglapp-run-finished'){
                this.startGratitude('endPlay')
                this.displayEndText = true
                setTimeout(() => {
                    $('#textPostBuild').css('opacity',1)
                }, 100);
                setTimeout(() => {
                    this.webGLBuild.endGame()
                }, 1000);
            }
            if(e && e == 'if-webglapp-loaded'){
                $('#app-container').css('min-height', $('#iframe-container').height())
            }
            if(e && e == 'if-webglapp-started'){
                this.startGratitude('startPlay')
            }
        }

    }

    replay(){
        if(isBrowser()){
            this.startGratitude('replay')
            this.webGLBuild.replay()
            $('#textPostBuild').css('opacity',0)
            setTimeout(() => {
                this.displayEndText = false
            }, 300);
        }
    }

    changeMouseStatus(status){
        if(isBrowser()){
            this.pointerLocked = status
        }
    }

    generateShareLink(){
        if(isBrowser()){
            var link = document.location.href.split('?')[0]
            var queryParams = []
            if(document.location.href.split('?').length>1){
                queryParams = queryParams.concat(document.location.href.split('?')[1].split('&'))
            }
            queryParams.push('src=mail')

            this.shareLink = 'mailto:?body='+encodeURIComponent(this.language.translate.instant('Bonjour')+
            '\n\n'+
            this.language.translate.instant('J’ai testé cette chasse aux risques dans un entrepôt.')+
            '\n'+
            this.language.translate.instant('C’est l’immersion totale pour former aux risques professionnels !')+
            '\n\n'+
            this.language.translate.instant('Tester ici :')+' '+link+'?'+queryParams.join('&'))
        }
    }

    startGratitude(type){
        console.log('startGratitude', type)
        this.gratitudes[type] = true
    }

    iframeLoaded(type){
        console.log('iframeLoaded', type)
        this.gratitudes[type] = false
    }


    getLikeNumberOnPage(){
        this.buttonLike.getLikeNumber(this.btnLikeName)
        .then(r => {
            if(r){
                this.likeNumber = Number(r['nbLikes'])
                this.userAlredyLike = r['haveILiked']
            }
        })
    }

    clickOnLikeBtn(){
        this.buttonLike.toggleLike(this.btnLikeName)
        .then(()=>{
            this.getLikeNumberOnPage()
        })
    }

    shareButton() {
      this.btnIsVisible = false
      setTimeout (() => {
        this.showSocialBtn = true;
      }, 1000);
    }

    checkUserLangForTwitterUrl() {
      this.currentLang = this.translate.store.currentLang;

      if (this.currentLang == 'en') {
        this.twitterUrl = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fimmersivefactory.com%2Ffr%2Fdemo&text=I%20tested%20this%20hazard%20spotting%20in%20a%20warehouse.%20It's%20a%20total%20immersion%20to%20train%20to%20professional%20risks!"
      } else {
        this.twitterUrl = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fimmersivefactory.com%2Ffr%2Fdemo&text=J%E2%80%99ai%20test%C3%A9%20cette%20chasse%20aux%20risques%20dans%20un%20entrep%C3%B4t.%20C%E2%80%99est%20l%E2%80%99immersion%20totale%20pour%20former%20aux%20risques%20professionnels%20!"
      }
    }

  redirectToCatalog() {
    this.router.navigateByUrl('/content?tags=245');
  }


}
